import { render, staticRenderFns } from "./ChoiceMultipleFeedback.vue?vue&type=template&id=2a2d9095&scoped=true&"
import script from "./ChoiceMultipleFeedback.vue?vue&type=script&lang=js&"
export * from "./ChoiceMultipleFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceMultipleFeedback.vue?vue&type=style&index=0&id=2a2d9095&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2d9095",
  null
  
)

export default component.exports